import type {ExtractPropsWithoutRef} from '@/types';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {useTranslation} from 'react-i18next';

type Props = ExtractPropsWithoutRef<'div'>;

export const NewFeatureBadge = styled((props: Props) => {
  const {t} = useTranslation('general');

  return <div {...props}>{t('new')}</div>;
})(
  ({theme}) => css`
    display: inline-flex;
    align-self: center;
    /* @FIXME it's clearly a label... */
    ${theme.typography.paragraphXSmallBold}
    text-transform: uppercase;
    padding: 4px;
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors.contentPromotionA};
    border-radius: 2px;
    user-select: none;
  `
);
